import React from 'react';
import moment from 'moment';
import { DrawerField, DrawerHeader } from '@paretogroup/tess';
import { Grid } from '@material-ui/core';
import LoadingSkeleton from '@shared/components/loading/LoadingSkeleton';
import { createColorFromName } from '@shared/utils/colors';
import { initialsName } from '../segments.utils';
import {
    StartIcon, Text, HeaderSubtitle, SegmentSelectedContainer,
} from './segments-header.styles';

interface SegmentSelectedProps {
    checked?: boolean;
    isDeletable?: boolean;
    isEditable?: boolean;
    label?: string;
    slug?: string;
}
interface DrawerHeaderComponentProps {
    headerSubtitle?: string;
    headerTitle?: string;
    userImage?: string;
    isLoading?: boolean;
    subMenu?: object;
    segmentSelected?: SegmentSelectedProps;
}

export const SegmentsHeader = ({
    headerTitle, userImage, isLoading, headerSubtitle, segmentSelected,
}: DrawerHeaderComponentProps) => (
    <DrawerHeader
        headerTitle={headerTitle}
        headerSubtitle={(
            isLoading
                ? <LoadingSkeleton width={135} height={16} />
                : <HeaderSubtitle>{headerSubtitle}</HeaderSubtitle>
        )}
        avatar={userImage}
    >
        <Grid item xs>
            <Grid container>
                <Grid item xs>
                    <Text>
                        Selected segment
                    </Text>
                </Grid>

                <Grid item>
                    <Text>
                        { moment().format('MMM D') }
                    </Text>
                </Grid>
            </Grid>
            {segmentSelected && !isLoading && (
                <SegmentSelectedContainer>
                    <DrawerField
                        label={segmentSelected.label}
                        startIcon={(
                            <StartIcon
                                backgroundColor={createColorFromName(segmentSelected.label)}
                            >
                                {initialsName(segmentSelected.label)}
                            </StartIcon>
                        )}
                    />
                </SegmentSelectedContainer>
            )}
        </Grid>
    </DrawerHeader>
);
